import { useQuery } from "@tanstack/react-query";
import z from "zod";

enum PaymentType {
  Free,
  OneTime,
  Recurring,
}

enum PaymentFrequency {
  Weekly = "week",
  Monthly = "month",
  Annually = "year",
}

const responseValidator = z.object({
  showAuthor: z.boolean(),
  showCoverArt: z.boolean(),
  showDescription: z.boolean(),
  showTitle: z.boolean(),
  feedImageUrl: z.string().nullish(),
  feedTitle: z.string(),
  feedAuthor: z.string(),
  description: z.string().nullish(),
  mode: z.number(),
  shouldAskForName: z.boolean(),
  shouldAskForPhone: z.boolean(),
  shouldRequireName: z.boolean(),
  shouldRequirePhone: z.boolean(),
  shouldRequireAgreement: z.boolean(),
  agreementText: z.string().nullish(),
  shouldIncludeTrackingCode: z.boolean(),
  trackingCode: z.string().nullable(),
  shouldUseCustomColor: z.boolean(),
  customColor: z.string(),
  pricingOptions: z.array(
    z.object({
      id: z.string().uuid(),
      label: z.string(),
      paymentType: z.nativeEnum(PaymentType),
      currency: z.string(),
      paymentAmount: z.number(),
      paymentFrequency: z.nativeEnum(PaymentFrequency),
      repeatPayment: z.boolean(),
      numberOfPayments: z.number(),
    }),
  ),
  subscribePageHeader: z.string().nullish(),
  signupPageHeader: z.string().nullish(),
  isTrial: z.boolean(),
});

import apiClient from "../apiClient";

export const fetchFeedSignupPageData = async (feedId: string) => {
  const response = await apiClient.get(`feed/signup-data?feedId=${feedId}`);
  if (!response.ok) throw new Error("Response failed!");
  return responseValidator.parse(await response.json());
};

export const useFeedSignupPageDataQuery = (feedId: string) => {
  return useQuery(["feedSignupData", feedId], () => fetchFeedSignupPageData(feedId));
};
